<header>
  <img
    src="logo_te.svg"
    width="60"
    title="TotalEnergies"
    alt="TotalEnergies"
    class="logo me-4 pointer"
    routerLink="/ingredients"
  />
  <div class="header-right">
    <div class="header-top">
      <div class="me-auto header-title">
        <div class="app-name me-3">
          {{ 'general.app_name' | translate }}
        </div>
      </div>

      @if (user()) {
        @if (canImpersonate) {
          <div class="me-3 impersonate m-auto">
            <mat-form-field>
              <mat-label>{{ 'messages.label.search' | translate }}</mat-label>
              <input type="text" matInput [formControl]="search" [matAutocomplete]="auto" />
              <mat-autocomplete
                #auto="matAutocomplete"
                (optionSelected)="impersonate($event.option.value)"
                [displayWith]="displayUser"
              >
                @for (user of usersToImpersonate(); track user.igg) {
                  <mat-option [value]="user"
                    >{{ user.igg | uppercase }} - {{ user.firstname }} {{ user.lastname | uppercase }} |
                    {{ user.role.label }}</mat-option
                  >
                }
              </mat-autocomplete>
              <mat-icon matSuffix color="primary" class="pointer ms-2" svgIcon="total-search"></mat-icon>
            </mat-form-field>
          </div>
        }

        @if (getEnvLabel()) {
          <span class="env-badge me-2">{{ getEnvLabel() }}</span>
        }

        <ng-container class="header-badge-container">
          <div class="header-badge user-badge" [matMenuTriggerFor]="userMenu">
            <span class="display-name">{{ getUserDisplayName() }}</span>
            <mat-icon color="primary" class="mb-1" svgIcon="total-user"></mat-icon>
          </div>

          <mat-menu
            #userMenu="matMenu"
            [overlapTrigger]="false"
            role="menu"
            attr.aria-label="{{ 'header.aria.menu_logout' | translate }}"
          >
            <button mat-menu-item [routerLink]="logoutRoute">
              {{ 'general.main_menu.logout' | translate }}
            </button>
          </mat-menu>
        </ng-container>
      }
    </div>

    <div
      class="d-flex"
      [class.justify-content-end]="!mpsUserService.isLoggedIn()"
      [class.justify-content-between]="mpsUserService.isLoggedIn()"
    >
      @if (mpsUserService.isLoggedIn()) {
        <mps-app-navigation></mps-app-navigation>
      }
      @if (translateService.getLangs().length > 1) {
        <div class="lang-dropdown" (click)="toggleDropdown()" (keyup)="toggleDropdown()" tabindex="0" role="button">
          <a class="lang-link" role="button" attr.aria-label="{{ 'header.aria.change_language' | translate }}">
            <mat-icon>language</mat-icon>
            <span class="current-lang">{{ getCurrentLangLabel() }}</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
          </a>
          <div class="lang-options" [class.open]="isDropdownOpen()">
            @for (lang of translateService.getLangs(); track lang) {
              <a
                mat-list-item
                (click)="switchLanguage(lang)"
                (keyup)="switchLanguage(lang)"
                role="button"
                tabindex="0"
                attr.aria-label="{{ 'header.aria.translate_to' | translate: { lang: getLangLabel(lang) } }}"
              >
                {{ getLangLabel(lang) }}
              </a>
            }
          </div>
        </div>
      }
    </div>

    <div (click)="nav?.toggle()" role="navigation" (keyup)="nav?.toggle()" class="burger-container" role="menu">
      <mat-icon class="burger menu" [ngClass]="{ active: !nav?.opened }">menu</mat-icon>
      <mat-icon class="burger close" [ngClass]="{ active: nav?.opened }">close</mat-icon>
    </div>
  </div>
</header>
